import { render, staticRenderFns } from "./PageBreadcrumb.vue?vue&type=template&id=425fcc6c&scoped=true&"
import script from "./PageBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./PageBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./PageBreadcrumb.vue?vue&type=style&index=0&id=425fcc6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425fcc6c",
  null
  
)

export default component.exports